module.exports = __webpack_public_path__ + "img/single-img-18.8e786fb6.jpg";